import { useWindowSize } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const TabComponent = ({ liveTV_id }) => {
  const router = useRouter();

  const tabs = [
    {
      id: "livetv-tak",
      label: "Tak 360",
      url: "/tak360-livetv",
      logo: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/360-logo-01.png?size=100:100",
      logo_active:"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/360-logo-06.png?size=100:100"
    },
    {
      id: "livetv-at",
      label: "Aajtak",
      url: "/aajtak-livetv",
      logo: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/aajtak_logo.png",
      logo_active: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/aajtak_logo.png",
    },
    {
      id: "livetv-it",
      label: "India Today",
      url: "/indiatoday-livetv",
      logo: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/it_logo.png",
      logo_active: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/it_logo.png",
    },
    {
      id: "livetv-gnt",
      label: "GNT TV",
      url: "/good-news-today-livetv",
      logo: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/gnt_logo.png",
      logo_active: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/gnt_logo.png",
    },
  ];
  const [activeTab, setActiveTab] = useState(liveTV_id || "livetv-tak");
  // Sync URL with the active tab
  useEffect(() => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (currentTab && router.pathname !== currentTab.url) {
      router.push(currentTab.url, undefined, { shallow: true });
    }
  }, [activeTab, router]);
  const size = useWindowSize();
  let height;
  if (size.width > 1024) {
    height = "454"; // Desktop
  } else if (size.width > 720 && size.width <= 1024) {
    height = "420"; // Tablet
  } else {
    height = "220"; // Mobile
  }

  return (
    <div className="max-w-4xl mx-auto mt-2 font-sans">
      <div className="flex md:flex-wrap  
  rounded-t-md  
  overflow-x-auto md:overflow-visible 
  scroll-smooth no-scrollbar">
  {tabs.map((tab) => (
    <a
  href={process.env.NEXT_PUBLIC_WEBSITE_URL + tab.url}
  key={tab.id}
  onClick={() => setActiveTab(tab.id)}
  className={`w-[150px] flex-shrink-0 flex md:flex-1 flex-row items-center justify-center gap-2
    py-3 px-4 font-semibold text-center cursor-pointer transition-all duration-300 rounded-t-md 
    ${
      activeTab === tab.id
        ? "bg-[#EA222A] text-white border-[#EA222A] shadow border "
        : "bg-white text-gray-700 hover:bg-gray-200 border "
    }
  `}
>
  <img
    src={activeTab === tab.id ? tab.logo_active : tab.logo}
    className="w-8 md:w-10"
  />
  <span className="whitespace-nowrap">{tab.label}</span>
</a>

  ))}
</div>


      {/* Tab Content */}

      {tabs.map(
        (tab) =>
          activeTab === tab.id && (
            <iframe
              key={tab.id}
              title={tab.label}
              className="w-full aspect-[16/9] "
              allowFullScreens
              id={`livetv-${tab.id}`}
              // width={"100%"}
              // height={height}
              src={router.asPath.includes("/tak360-livetv") ?  "https://www.youtube.com/embed/BtqcvDxoE6o?si=1UnaiYJRQd2HnJpX&autoplay=1&mute=1" :
                 `https://feeds.intoday.in/livetv/ver-3-0/?id=${tab.id}&autostart=1&mute=1&sharing=${tab.id=="livetv-tak" ?0:1}&noads=1`
              }
              scrolling="no"
              frameBorder="0"
              allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope"
              mozallowfullscreen
              webkitallowfullscreen
            ></iframe>
          )
      )}
      
    </div>
  );
};

export default TabComponent;
